import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import emailjs from "emailjs-com";
import "./BookNow.css";
export default function BookNow() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    title: "",
  });

  const [status, setStatus] = useState({ success: false, error: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Replace these with your EmailJS keys
    const serviceId = "your_service_id";
    const templateId = "your_template_id";
    const userId = "your_user_id";

    emailjs.send(serviceId, templateId, formData, userId)
      .then(() => {
        setStatus({ success: true, error: "" });
        setFormData({ name: "", mobile: "", email: "", title: "" });
      })
      .catch((err) => {
        setStatus({ success: false, error: "Something went wrong!" });
        console.error(err);
      });
  };

  return (
    <Container className="mt-5 book-now-container">
      <Row className="justify-content-center">
        <Col md={6}>
          <h2 className="mb-4 text-center">Book Your Spot</h2>
          
          {status.success && <Alert variant="success">✅ Booking successful! Check your email.</Alert>}
          {status.error && <Alert variant="danger">{status.error}</Alert>}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control 
                type="text" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mobile No.</Form.Label>
              <Form.Control 
                type="tel" 
                name="mobile" 
                value={formData.mobile} 
                onChange={handleChange} 
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control 
                type="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Workshop Title</Form.Label>
              <Form.Control 
                type="text" 
                name="title" 
                value={formData.title} 
                onChange={handleChange} 
                required 
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Book Now
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
